import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Cpu, Layers } from "lucide-react";

export default function Hero() {
  return (
    <section className="relative pt-32 pb-24 md:pt-44 md:pb-32 overflow-hidden bg-white" data-testid="hero-section">
      <div className="absolute inset-0 blueprint-grid" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-white" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
          className="max-w-4xl">
          <div className="inline-flex items-center gap-2 border border-slate-200 bg-white px-3 py-1.5 text-xs uppercase tracking-[0.2em] font-semibold text-ember">
            <span className="h-1.5 w-1.5 bg-ember rounded-full" /> Acquisition &amp; Retention Solutions
          </div>

          <h1 className="mt-7 font-heading font-extrabold tracking-tighter text-ink text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">
            Visionary Growth<br />Partners.
          </h1>

          <p className="mt-7 text-lg md:text-xl text-slatey max-w-2xl leading-relaxed">
            Empowering the future of enterprise and SMB growth. We combine cutting-edge physical AV infrastructure
            with autonomous Agentic AI marketing to deliver measurable, outcome-based solutions.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a href="#ecosystem" data-testid="hero-explore-tech"
               className="group inline-flex items-center justify-center gap-2 bg-ink text-white px-7 py-4 text-sm font-semibold hover:bg-ink-soft transition-colors">
              Explore Our Technology
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <a href="#verticals" data-testid="hero-discover-verticals"
               className="inline-flex items-center justify-center gap-2 border border-ink text-ink px-7 py-4 text-sm font-semibold hover:bg-slate-50 transition-colors">
              Discover Our Industry Verticals
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-20 grid grid-cols-1 sm:grid-cols-3 border border-slate-200 divide-y sm:divide-y-0 sm:divide-x divide-slate-200 bg-white">
          {[
            { icon: Layers, k: "Hardware + Brainpower", v: "Physical AV meets strategic AI marketing." },
            { icon: Cpu, k: "Powered by HaloFlow", v: "24/7 autonomous agentic execution." },
            { icon: ArrowRight, k: "Outcome-Based", v: "Measurable acquisition & retention." },
          ].map((s, i) => (
            <div key={i} className="p-7 flex items-start gap-4">
              <s.icon className="h-5 w-5 text-ember mt-0.5 shrink-0" />
              <div>
                <div className="font-heading font-bold text-ink">{s.k}</div>
                <div className="text-sm text-slatey mt-1">{s.v}</div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
